import { useState } from "react"
import { observer } from "mobx-react"
import { Flex, Form } from "antd"
import { choose } from "choose-matching"

import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { FormOTP } from "@src/shared/componemts/FormOTP"
import {
  RefundEntity,
  RefundFormType,
} from "@src/shared/componemts/RefundForm/classses/RefundEntity"
import { RefundFormHeader } from "@src/shared/componemts/RefundForm/ui/RefundFormHeader"
import { RefundInnerForm } from "@src/shared/componemts/RefundForm/ui/RefundInnerForm"
import { RefundSuccess } from "@src/shared/componemts/RefundForm/ui/RefundSuccess"

type Props = {
  refund: RefundEntity
}
export const RefundForm = observer(({ refund }: Props) => {
  const [form] = Form.useForm()
  const [isConfirmed, setIsConfirmed] = useState(false)
  const [isOtpOpen, setIsOtpOpen] = useState(false)

  const onFormSubmit = (values: RefundFormType) => {
    refund.setState(values)

    setIsOtpOpen(true)
  }

  const onOtpSubmit = async (otp: string) => {
    return refund.create({ otp }).then((isCreated) => {
      setIsConfirmed(isCreated)
    })
  }

  return (
    <DefaultPageLayout
      isLoading={refund.isLoading}
      {...(isOtpOpen
        ? { backAction: () => setIsOtpOpen(false), title: "2FA check" }
        : { title: "Refund" })}
    >
      <>
        {choose(
          [
            isOtpOpen,
            <FormOTP onSubmit={onOtpSubmit} setVisible={setIsOtpOpen} />,
          ],
          [isConfirmed, <RefundSuccess />],
          [
            true,
            <Flex gap={32} style={{ margin: "0 auto", width: "50%" }} vertical>
              <RefundFormHeader payment={refund.paymentInfo} />

              <RefundInnerForm
                form={form}
                isLoading={refund.isLoading}
                onFinish={onFormSubmit}
              />
            </Flex>,
          ],
        )}
      </>
    </DefaultPageLayout>
  )
})
